module.exports = __webpack_public_path__ + "static/media/014 color panel.b2631339.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/014 color panel.png
// module id = 393
// module chunks = 0